import axiosRagflow from 'constants/axios';
import * as Document from 'containers/desktop/KnowledgeBases/types/Document';

export * as DocumentList from 'containers/desktop/KnowledgeBases/types/DocumentList';

export type Type = Document.Type[];

export function create(): Type {
	return [];
}

export async function getAllFromApi(knowledgeBaseId: string): Promise<Type> {
	const response = await axiosRagflow.get(`/api/v1/datasets/${knowledgeBaseId}/documents`, {
		params: {},
	});
	if (!response) return create();
	if (!response?.data?.data?.docs) return create();
	if (!response?.data?.data?.docs?.length) return create();
	return response?.data?.data?.docs?.map((item: any) => Document.mapFromApi(item));
}

export async function parseFromApi(
	list: Type,
	documentId: string,
	knowledgeBaseId: string
): Promise<Type> {
	const output: Type = [];
	for (const document of list) {
		if (document.id === documentId) {
			output.push(await Document.parseAtApi(document, knowledgeBaseId));
		} else {
			output.push(document);
		}
	}
	return output;
}

export async function stopParsingFromApi(
	list: Type,
	documentId: string,
	knowledgeBaseId: string
): Promise<Type> {
	const output: Type = [];
	for (const document of list) {
		if (document.id === documentId) {
			output.push(await Document.stopParsingAtApi(document, knowledgeBaseId));
		} else {
			output.push(document);
		}
	}
	return output;
}
